$(document).ready(function () {
  
  $(".slider-range").on( "input", function() {
    var divisor = $(this).parents(".faq-block").find(".divisor")
    var handle = $(this).parents(".faq-block").find(".handle");
    var slider = $(this).parents(".faq-block").find(".slider-range");
    handle.css("left",  slider.val()+"%");
    divisor.css("width",  slider.val()+"%");
  });
  var rtlFlag = ($('body').hasClass('lang-rtl')) ? true: false;
  
    $('.reassurance-list').owlCarousel({
        nav: false,
        navText: [
          '<i class=\'fa fa-arrow-left\'></i>',
          '<i class=\'fa fa-arrow-right\'></i>'
        ],
        dots: true,
        loop: false,
        margin: 15,
        autoplay: true,
        autoplayTimeout: 5000,
        rtl: rtlFlag,
        rewind: true,
        autoHeight: true, // Auto adjust height based on content
        onChanged: function () {
          setTimeout(function () {
            $('.reassurance-list').trigger('refresh.owl.carousel');
          }, 100); // Increased timeout to 100 milliseconds
        },
        responsive:  {
          0: {
            items: 1
          },
          320: {
            items: 1
          }
        }
      });
  //BACK TO TOP JAVASCRIPT START
  $(window).scroll(function () {
    if ($(this).scrollTop() > 500) {
      $('#slidetop').fadeIn(500);
      $('.whatsapp-floating-button').addClass('slidetop-visible');
    } else {
      $('#slidetop').fadeOut(500);
      $('.whatsapp-floating-button').removeClass('slidetop-visible');
    }
  });
  $('#slidetop').click(function (e) {
    e.preventDefault();
    $('html, body').animate({
      scrollTop: 0
    }, 800);
  });
  //BACK TO TOP JAVASCRIPT END
  
  //DISABLED ZOOM FOR VIDEO JAVASCRIPT START
  $(".product__media-item").click(function(){
    if($(this).attr("data-media-type") == 'video'){
      $('.zoomContainer').hide();
    }else{
      $('.zoomContainer').show();
    }
  });
   //DISABLED ZOOM FOR VIDEO JAVASCRIPT END
  
  //DEFAULT COLLAPSE JAVASCRIPT START
 $(document).on("click","[data-toggle='collapse']",function() {
    var parent = $(this).data("parent");
    var target = $(this).data("href");
    if($(parent).length && $(parent).hasClass('panel-group')) {
     $(parent+" .panel").each(function() {
       var p = $(this).find("[data-toggle='collapse']");
       var t = p.data("href");
       if(t!= target && p.attr("aria-expanded") == "true") {
        $(t).slideUp().removeClass("in");
        p.addClass("ishi-collapsed").attr("aria-expanded","false");
       } 
     });
    } 
    if($(this).attr("aria-expanded") == "false") {
      $(target).slideDown().addClass("in");
      $(this).removeClass("ishi-collapsed").attr("aria-expanded","true");
    } else {
      $(target).slideUp().removeClass("in");
      $(this).addClass("ishi-collapsed").attr("aria-expanded","false");
    }
  });
  //DEFAULT COLLAPSE JAVASCRIPT END
  
  //DEFAULT POPOVER JAVASCRIPT START
  $(document).on("click","[data-toggle='popover']",function() {
    var target = $(this).data("href");
    if($(this).attr("aria-expanded") == "false") {
      $(target).addClass("active");
      $(this).attr("aria-expanded","true");
    } else {
      $(target).removeClass("active");
      $(this).attr("aria-expanded","false");
    }
  });
  $(document).on("click", function(event){
    if(!$(event.target).closest('#search-container-full').length && !$(event.target).closest('[data-href="#search-container-full"]').length){
      if($('[data-href="#search-container-full"]').attr("aria-expanded") == "true") {
        $("#search-container-full").removeClass("active");
        $('[data-href="#search-container-full"]').attr("aria-expanded","false");
      }
    }
    
    if(!$(event.target).closest('#user-notification').length && !$(event.target).closest('[data-href="#user-notification"]').length){
      if($('[data-href="#user-notification"]').attr("aria-expanded") == "true") {
        $("#user-notification").removeClass("active");
        $('[data-href="#user-notification"]').attr("aria-expanded","false");
        event.preventDefault();
      }
    }
    
    if(!$(event.target).closest('#HeaderCountryList').length && !$(event.target).closest('[data-href="#HeaderCountryList"]').length){
      if($('[data-href="#HeaderCountryList"]').attr("aria-expanded") == "true") {
        $("#HeaderCountryList").removeClass("active");
        $('[data-href="#HeaderCountryList"]').attr("aria-expanded","false");
      }
    }
    
    if(!$(event.target).closest('#HeaderLanguageList').length && !$(event.target).closest('[data-href="#HeaderLanguageList"]').length){
      if($('[data-href="#HeaderLanguageList"]').attr("aria-expanded") == "true") {
        $("#HeaderLanguageList").removeClass("active");
        $('[data-href="#HeaderLanguageList"]').attr("aria-expanded","false");
      }
    }
    
    
  });
  //DEFAULT POPOVER JAVASCRIPT END
  
  //DEFAULT TABS JAVASCRIPT START
  $(document).on("click",".ishi-nav-link",function() {
    $(this).parents(".ishi-nav-tabs").find(".ishi-tab-item").removeClass("active");
    $(this).parents(".ishi-tab-item").addClass("active");
    
    $(this).parents(".ishi-product-tab").find(".ishi-tab-pane").removeClass("active");
    var target = $(this).data("href");
    $(target).addClass("active");
  });
  //DEFAULT TABS JAVASCRIPT END
  
  //DEFAULT PANEL JAVASCRIPT START
  $(document).on("click",'[data-action="ishi-panel"]',function() {
    var target = $(this).attr("aria-controls");
    $(this).parents(".ishi-panel-container").find(".ishi-panel-data").removeClass("active");
    $(target).addClass("active");
  });
  //DEFAULT PANEL JAVASCRIPT END
  
  //DEFAULT WISHLIST JS START  
  if($(".add-in-wishlist-js").length != 0) {
    $(document).on("click", ".add-in-wishlist-js", function(event){
    if($(this).hasClass("added-wishlist")) return true;
    event.preventDefault();
    try {
      var id = $(this).data('href');
      if(getTheCookie("wishlist") == null) {
        var str = id;
      } else {
        if(getTheCookie("wishlist").indexOf(id) == -1) {
          var str = getTheCookie("wishlist") + '__' + id;
        }
      }
      setTheCookie("wishlist", str, 14);
      $('.loadding-wishbutton-'+id).show();
      $('.default-wishbutton-'+id).remove();
      setTimeout(function(){ 
        $('.loadding-wishbutton-'+id).remove(); $('.added-wishbutton-'+id).show();
                           
      }, 2000);
     } catch (err) {
        console.log("error reading wishlist cookies!");
     }
    });
  }
  setupWishlistButtons();
  //DEFAULT WISHLIST JS END
  
  //CART PAGE EDIT BUTTON JAVASCRIPT START
  $(document).on("click",".js-edit-toggle",function() {
    $(this).parents("tr").toggleClass("cart__update--show");
    $(this).toggleClass("cart__edit--active");
  });
  //CART PAGE EDIT BUTTON JAVASCRIPT END
  
  //STOCK URGENCY START
      var stock = parseInt($("#variant-stock").html());
      var maxqty = parseInt($(".selected-variant").data("quantity"));
      if(stock == '' || stock <= 0) {
        $(".ishi-progress-content").addClass('hidden');
      }
      switch(stock){case 9:$("#ishi-progress-bar span").css("width","65%");break;case 8:$("#ishi-progress-bar span").css("width","60%");break;case 7:$("#ishi-progress-bar span").css("width","55%");break;case 6:$("#ishi-progress-bar span").css("width","50%");break;case 5:$("#ishi-progress-bar span").css("width","40%");break;case 4:$("#ishi-progress-bar span").css("width","30%");break;case 3:$("#ishi-progress-bar span").css("width","20%");break;case 2:$("#ishi-progress-bar span").css("width","10%");break;case 1:$("#ishi-progress-bar span").css("width","5%");break;default: $("#ishi-progress-bar span").css("width","90%")}
  //STOCK URGENCY END
  
  //PRODUCT MEDIA CHANGE ON CLICK JAVASCRIPT START
    $(document).on("click",".product__media-list .product__media-item",function(){
      if($(this).data("media-type") != "model") $('#main-media-container').html($(this).clone());
    });
    if($("#main-media-container").length && window.matchMedia("(min-width: 991px)").matches){
      $("#main-media-container img").elevateZoom({zoomType: "inner", cursor: "crosshair"});
    }
    $(document).on("DOMSubtreeModified", "#main-media-container",function() {
      if(window.matchMedia("(min-width: 991px)").matches && $(this).find(".product__media-item").data("media-type") != "video") {
         $("#main-media-container img").elevateZoom({zoomType: "inner", cursor: "crosshair"});
      }
    }); 
  //PRODUCT MEDIA CHANGE ON CLICK JAVASCRIPT END
  
  //PRODUCT THUMBNAILS SLIDER INITIALIZE JAVASCRIPT START
  $('.product__media-list').owlCarousel({
    nav: true,
    navText: [
      '<i class=\'fa fa-angle-left\'></i>',
      '<i class=\'fa fa-angle-right\'></i>'
    ],
    dots: false,
    loop: false,
    margin: 15,
    rtl: rtlFlag,
    rewind: true,
    responsive:  {
      0: {
        items: 3
      },
      544: {
        items: 4
      },
      768: {
        items: 3
      },
      992: {
        items: $('#shopify-section-Ishi_sidebar').length ? 3 : 4
      },
      1200: {
        items: 4
      }
    }
  });
  //PRODUCT THUMBNAILS SLIDER INITIALIZE JAVASCRIPT END
  
  //COLLECTION GRID-LIST JAVASCRIPT START
  $(document).on("click",".collectiongrid-layout",function() {
    var id = $(this).data("id");
    setTheCookie("collectiongrid-layout", id, 14);
    setGridLayout();
  });
  setGridLayout();
  //COLLECTION GRID-LIST JAVASCRIPT END
  
  
  //CART BUTTONS SCRIPT START
  $(document).on("click",".add-to-cart-js",function(event) {
    event.preventDefault();
  	var variantID = this.getAttribute("data-variantid");
    var quantity = 1;
    var $qtyInput = $(this).closest('.product-info').find('.qty-input');
    if ($qtyInput.length === 0) {
       $qtyInput = $(this).closest('.product-container').find('.qty-input');
    }
    if ($qtyInput.length > 0) {
      quantity = parseInt($qtyInput.val(), 10) || 1;
    }
    $(this).addClass("loading");
    addToCartJS(quantity, variantID, this);
  });
  
  $(document).on("click",".cart-remove-js",function() {
  	var variantID = this.getAttribute("data-variantid");
    removeFromCartJS(variantID);
  });
var cartQtyUpdateTimers = {};
$(document).on("change", ".quantity__input", function() {
    // Get the variant ID from the sibling button
    var variantID = $(this).siblings(".minicart-quantity__button").attr("data-variantid");
    if (!variantID) return;

    var quantity = $(this).val();
    // Debounce per variant: rapid +/- clicks collapse into one request with
    // the final quantity. One request per click trips Shopify's cart API
    // rate limit (429), which used to error out and reload the page.
    clearTimeout(cartQtyUpdateTimers[variantID]);
    cartQtyUpdateTimers[variantID] = setTimeout(function() {
      delete cartQtyUpdateTimers[variantID];
      updateCartItemJS(quantity, variantID);
    }, 500);
});
$(document).on("click","quickview-opener .product-popup-modal__button",function() {
    $(".quantity__input").val(1);
});
  //CART BUTTONS SCRIPT END
  
  //QUICKVIEW SCRIPT START
  $(document).on("click",".quick-view",function() {
  	var handle = $(this).data("handle");
    loadQuickView(handle, $(this));
  });
  //QUICKVIEW SCRIPT END
  
  //SIDEBAR FILTERS SCRIPT START 
  if($("#FacetFiltersFormSidebar [type='checkbox']:checked").length) {
		$("#FacetFiltersFormSidebar .clear-all").css("display","inline-block");
	}
  //SIDEBAR FILTERS SCRIPT END 
  
  // INITIALIZE JS START
  $( ".owl-carousel.slider-with-options" ).each(function( index ) {
    $(this).owlCarousel({
      lazyLoad: true,
      navText: [
        '<i class=\'fa fa-angle-left\'></i>',
      	'<i class=\'fa fa-angle-right\'></i>'
      ],
      loop: ($(this).data("loop")) ? true :false,
      rewind: ($(this).data("rewind")) ? true :false,
      nav: ($(this).data("nav")) ? true :false,
      rewind: ($(this).data("rewind")) ? true :false,
      autoplay: ($(this).data("autoplay")) ? true :false,
      rtl: rtlFlag,
      dots: ($(this).data("dots")) ? true :false,
      autoplayTimeout: ($(this).data("autoplaytimeout")) ? $(this).data("autoplaytimeout") :4000,
      smartSpeed: ($(this).data("smartspeed")) ? $(this).data("smartspeed") :500,
      margin: ($(this).data("margin")) ? $(this).data("margin") : 0,
      responsive:  {
        0: {
          items: $(this).data("small")
        },
        544: {
          items: $(this).data("mobile")
        },
        768: {
          items: $(this).data("tablet")
        },
        992: {
          items: $(this).data("laptop")
        },
        1200: {
          items: $(this).data("desktop")
        }
      }
    });
  });
  // INITIALIZE JS END
  
  //COUNTDOWN TIMER START
  $('[data-deal="1"]').each(function( index ) {
    setCountDownTimer($(this).data("counter"), this.querySelector(".countdowncontainer"));
  });
  //COUNTDOWN TIMER END
  
  //WRITE COMMENT JS START
  $(".write_comment").click(function(e) {
    $('.ishi-product-tab .ishi-nav-tabs a.review-tab').trigger('click');
    $('html, body').animate({scrollTop: $(".ishi-product-tab").offset().top - 50}, 2000);
  });
  //WRITE COMMENT JS END
  
  //fixed header
  adjustFixedHeader();
  $(window).scroll(function(){
    adjustFixedHeader();
  });
  
 
  
  var shopify_responsive_current_width = window.innerWidth;
  var shopify_responsive_min_width = 992;
  var shopify_responsive_mobile = shopify_responsive_current_width < shopify_responsive_min_width;

  if (shopify_responsive_mobile) {
    convertToMobile();
  }
  
  $(window).on('resize', function () {
    var _mw = shopify_responsive_min_width;
    var _w = window.innerWidth;
    var desktopElement = $("*[id^='_desktop_']").first();
    var desktopContent = (desktopElement.length && desktopElement.html()) ? desktopElement.html().trim().length: 0;
    var mobileElement = $("*[id^='_mobile_']").first();
    var mobileContent = (mobileElement.length && mobileElement.html()) ? mobileElement.html().trim().length: 0;
    if(_w < _mw && desktopContent) {
      convertToMobile();
    } 
    if(_w >= _mw && mobileContent) {
      convertToDesktop();
    } 
  });
  
  $('#menu-icon').on('click', function() {
    $("#mobile_top_menu_wrapper").animate({
      width: "toggle"
    });
    $('.mobile-menu-overlay').toggleClass("active");
  });

  $('#top_menu_closer svg').on('click', function() {
    $("#mobile_top_menu_wrapper").animate({
      width: "toggle"
    });
    $('.mobile-menu-overlay').toggleClass("active");
  });
  
  $('.mobile-menu-overlay').on('click', function() {
    $("#mobile_top_menu_wrapper").animate({
      width: "toggle"
    });
    $('.mobile-menu-overlay').toggleClass("active");
  });
 $(document).on('click', '.cart-drawer-toggler', function(event) {
    event.preventDefault();
    openCartDrawer();
  });


  $('#cart-notification-closer svg').on('click', function() {
    closeCartDrawer();
  });
  $('#cart-notification-closer-btn').on('click', function() {
    closeCartDrawer();
  });
  
  $('.cart-overlay').on('click', function() {
    closeCartDrawer();
  });
});





function convertToMobile(){
  //interchange sections

  $("*[id^='_desktop_']").each(function(index, element) {
    var target = $('#' + element.id.replace('_desktop_', '_mobile_'));
    swapElements($(this), target);
  });

  $(window).scroll(function () {
    if ($(this).scrollTop() > 1000) {
      $('.sticky-cartbtn').fadeIn(500);
    } else {
      $('.sticky-cartbtn').fadeOut(500);
    }
  });
  $(".stickyaddtocart").show();
}
function convertToDesktop() {
  //interchange sections

  $("*[id^='_mobile_']").each(function(index, element) {
    var target = $('#' + element.id.replace('_mobile_', '_desktop_'));
    swapElements($(this), target);
  });
  
  $("#main-media-container").length ? $("#main-media-container img").elevateZoom({zoomType: "inner", cursor: "crosshair"}): "";
  $(".stickyaddtocart").hide();
}

function swapElements(source, destination) {
  var temp = destination.children().detach();
  destination.empty().append(source.children().detach());
  source.append(temp);
}



function adjustFixedHeader() {
    var headerHeight = $('#header').height();
    var navmenuHeightDesktop = $('.nav-height .navfullwidth').height();
    var navfullwidthHeightDesktop = headerHeight + navmenuHeightDesktop;
    var navHeightDesktop = headerHeight;
    var navHeightMobile = $('#header').height();

    if ($("#header-layout1").length) {
     if(window.matchMedia('(min-width: 992px)').matches) {
        $('.mobile-width').removeClass('fixed-header');
        if ($(window).scrollTop() > navHeightDesktop) {
          $('.header-top').addClass('fixed-header');
        }
        else {
          $('.header-top').removeClass('fixed-header');
        }
      }

      if(window.matchMedia('(max-width: 991px)').matches) {
        $('.header-top').removeClass('fixed-header');
        if ($(window).scrollTop() > navHeightMobile) {
          $('.mobile-width').addClass('fixed-header');
        }
        else {
          $('.mobile-width').removeClass('fixed-header');
        }    
      }
    }
    if ($("#header-layout2").length) {
     if(window.matchMedia('(min-width: 992px)').matches) {
        $('.mobile-width').removeClass('fixed-header');
        if ($(window).scrollTop() > navfullwidthHeightDesktop) {
          $('.navfullwidth').addClass('fixed-header');
        }
        else {
          $('.navfullwidth').removeClass('fixed-header');
        }
      }

      if(window.matchMedia('(max-width: 991px)').matches) {
        $('.navfullwidth').removeClass('fixed-header');
        if ($(window).scrollTop() > navHeightMobile) {
          $('.mobile-width').addClass('fixed-header');
        }
        else {
          $('.mobile-width').removeClass('fixed-header');
        }    
      }
    }
  
}

$(function() {
  // Current Ajax request.
  var currentAjaxRequest = null;
  // Grabbing all search forms on the page, and adding a .search-results list to each.
  var searchForms = $('form[action="/search"]').css('position','relative').each(function() {
    // Grabbing text input.
    var input = $(this).find('input[name="q"]');
    // Adding a list for showing search results.
    var offSet = input.position().top + input.innerHeight();
    $('<ul class="search-results"></ul>').css( { 'position': 'absolute', 'left': '0px', 'top': offSet } ).appendTo($(this)).hide();    

    // Listening to keyup and change on the text field within these search forms.
    input.attr('autocomplete', 'off').bind('keyup change', function() {
      // What's the search term?
      var term = $(this).val();
      if(term !== ""){
        $(".search-header .search-results").show();
        $(".search-header .suggestion-tags").hide();
      } else {
        $(".search-header .search-results").hide();
        $(".search-header .suggestion-tags").show();
      }
      // What's the search form?
      var form = $(this).closest('form');
      // What's the search URL?
      var searchURL = '/search?type=product&q=' + term;
      // What's the search results list?
      var resultsList = form.find('.search-results');
      // What's the suggestion tags container?
      // var suggestionTagsContainer = form.find('.suggestion-tags');
      
      // If that's a new term and it contains at least 3 characters.
      if (term.length > 3 && term != $(this).attr('data-old-term')) {
        // Saving old query.
        $(this).attr('data-old-term', term);
        // Killing any Ajax request that's currently being processed.
        if (currentAjaxRequest != null) currentAjaxRequest.abort();
        // Pulling results.
        currentAjaxRequest = $.getJSON(searchURL + '&view=json', function(data) {
          // Reset results.
          resultsList.empty();
          // suggestionTagsContainer.empty(); // Clear existing suggestion tags.

          // If we have no results.
          if(data.results_count == 0) {
            // resultsList.html('<li><span class="title">No results.</span></li>');
            // resultsList.fadeIn(200);
            resultsList.hide();
          } else {
            // If we have results.
            $.each(data.results, function(index, item) {
              var link = $('<a></a>').attr('href', item.url);
              link.append('<span class="thumbnail"><img src="' + item.thumbnail + '" /></span>');
               link.append('<span class="type">' + item.type + '</span>');
              link.append('<span class="title">' + item.title + '</span>');
              link.append('<span class="price">' + item.price + '</span>');
              link.wrap('<li></li>');
              resultsList.append(link.parent());
            });

            // // Extract suggestion tags from the results and display them.
            // var suggestionTags = getSuggestionTags(data.results);
            // suggestionTagsContainer.html('<strong>Trending: </strong> ' + suggestionTags.join(', ')).fadeIn(200);

            // resultsList.fadeIn(200);
          }        
        });
      }
    });
  });
  // Clicking outside makes the results disappear.
  $('body').bind('click', function(){
    $('.search-results').hide();
  });

  function boldstuffSetCardVariantLink(cardWrap, variantId) {
    if (!cardWrap || !variantId) return;
    var $wrap = $(cardWrap);

    // Cache base URLs once so we don't keep appending params
    $wrap.find('a.card-image-link, a.card-details-link, a.full-unstyled-link').each(function () {
      var $a = $(this);
      if (!$a.attr('data-base-href')) {
        var href = $a.attr('href') || '';
        var baseHref = href.split('?')[0];
        $a.attr('data-base-href', baseHref);
      }
      var base = $a.attr('data-base-href');
      if (base) $a.attr('href', base + '?variant=' + variantId);
    });
  }

  $(document).on("click",".variants-swatch .color-box",function() {
    var image = this.getAttribute("data-image");
    $(this).parents('.variants-swatch').find('.swatch-label').removeClass('active');
    var $label = $(this).parents('.swatch-label');
    $label.addClass('active');
    var $card = $(this).parents('.card-wrapper');
    $card.find('.thumbnail .primary-image').attr('src', image);
    $card.find('.thumbnail .primary-image').attr('srcset', image);

    // Ensure opening PDP keeps the chosen color/variant
    var variantId = $label.data('variant-id');
    boldstuffSetCardVariantLink($card, variantId);
  });

  // On load: if a swatch is already active, keep card links in sync
  $('.variants-swatch .swatch-label.active').each(function () {
    var $label = $(this);
    var variantId = $label.data('variant-id');
    var $card = $label.closest('.card-wrapper');
    boldstuffSetCardVariantLink($card, variantId);
  });

 
$(document).on('click', '.item-swatch-more .number-showmore', (event) => {
    if ($(event.target).closest('.variants-swatch').hasClass('show--more')) {
      $(event.target).closest('.variants-swatch').removeClass('show--more');
    }
    else{
      $(event.target).closest('.variants-swatch').addClass('show--more');
    }
  });
});

//QUICKVIEW FUNCTIONS START

var variantAvailability = [];
var variantFeaturedImg = [];
var variantIndexIdMapping = [];
var currentVariants = {};
var availableVariants = [];
var variantCompareAtPrice = [];
var variantPrice = [];

function loadQuickView(handle,btn) {
  variantAvailability = [];
  variantFeaturedImg = [];
  variantIndexIdMapping = [];
  currentVariants = {};
  availableVariants = [];
  variantCompareAtPrice = [];
  variantPrice = [];
  $("#qv-variants").html('');
  
  jQuery.getJSON('/products/' + handle + '.js', function (product) {
    $("#qv-productname").html(product.title);
    $("#qv-productdescription").html(product.description);
    if(product.description.length < 300) {
    	$(".more-description").css("display","none");
    }else{
        $(".more-description").css("display","block");
    }
    $("#qv-product-cover img").attr("src",product.featured_image);
    var reviews = $('[data-handle="'+ handle +'"]').parents(".card-wrapper").find(".spr-badge").clone();
    $("#qv-spr-badge").html(reviews.html());

    //prepare thumbnails
    prepareQvThumbnails(product.images);

    if(product.variants.length > 1) {
      //prepare swatches
      var colorNameList = "color,colour,couleur,colore,farbe,색,色,färg,farve";
      colorNameList = colorNameList.split(",");
      $(product.options).each(function (i, option) {
        var name = option.name;
        var includesColor = colorNameList.includes(name.toLowerCase());
        var swatchWrapper = $('<div class="swatch-wrapper" data-index="' + option.position + '"></div>');
         var optionValues =  $('<div class="option-values product-form__input ' + name.toLowerCase() +'"></div>');
        swatchWrapper.append('<div class="option-label"><label>' + name + '</label></div>')
        $(option.values).each(function (i, value) {
          var checked = '';
          if(i==0) checked = 'checked';
          optionValues.append('<input id="' + name + '-' + i + '" type="radio" value="' + value + '" name="' + name +'"' + checked  +'>');
          var className = (includesColor || value.length < 3) ? "square" : "label"; 
          if(includesColor) {
            var dummyImg = "//boldstuff.in/cdn/shop/files/dummy?v=1569";
            var dummyImgURL = dummyImg.substr(0, dummyImg.indexOf('dummy'));
            var dummyImgVersion = dummyImg.substr(dummyImg.indexOf('?'));
            var imgURL = "background-color: " + value + "; background-image: url('"+ dummyImgURL + value + ".png" + dummyImgVersion +"')";
          	optionValues.append('<label style="'+ imgURL + '" for="' + name + '-' + i + '" data-color="' + value +'" data-index="'+ i +'"></label>');
          } else {
            optionValues.append('<label for="' + name + '-' + i + '" class="' + className +'" data-index="'+ i +'">' + value + '</label>');
          }
          
        });
        swatchWrapper.append(optionValues);
        $("#qv-variants").append(swatchWrapper);
      });    

      //prepare dropdown
      $(product.options).each(function (i, option) {
        var name = option.name;
        var selectWrapper = $('<div class="dropdown-wrapper"></div>');
        var optionValues = $('<div class="option-values product-form__input"></div>');
        var selectBoxWrapper =  $('<div class="select"></div>');
        var selectBox =  $('<select id="select-option' + option.position + '" name="options[' + option.position + ']" class="select__select"></select>');
        selectWrapper.append('<div class="option-label"><label>' + name + '</label></div>')
        $(option.values).each(function (i, value) {
          var selected = '';
          if(i==0) selected = 'selected';
          selectBox.append('<option value="' + value +'" ' + selected +'>' + value + '</option>');
        });
        selectBoxWrapper.append(selectBox);
        optionValues.append(selectBoxWrapper);
        selectWrapper.append(optionValues);
        $("#qv-variants").append(selectWrapper);
      });
      
      $(product.variants).each(function(index,variant) {
        var variantsList = variant.title.split("/");
        var variantsKeyVal = {};
        for(var i=0; i < variantsList.length; i++) {
          variantsKeyVal["select-option" + (i+1)] = variantsList[i].trim();
        }
        variantIndexIdMapping.push(variant.id);
        availableVariants.push(variantsKeyVal);
        variantAvailability.push(variant.available);
        variantFeaturedImg.push(variant.featured_image.src);
        variantCompareAtPrice.push(variant.compare_at_price);
        variantPrice.push(variant.price);
      });
      loadCurrentQvVariants();
      updateQvVariantDetails();
    } else {
      var variant = product.variants[0];
      $("#qv-variantid").val(variant.id);
      if(variant.available){
      	$("#qv-add-to-cart").removeClass("sold-out");
      } else {
      	$("#qv-add-to-cart").addClass("sold-out");
      }
      if(variant.compare_at_price != null && variant.compare_at_price > variant.price) {
        $("#qv-compareatprice").html(convertToMoney(variant.compare_at_price));
        $("#qv-price").html(convertToMoney(variant.price));
      } else {
        $("#qv-compareatprice").html('');
        $("#qv-price").html(convertToMoney(variant.price));
      }
    }
    $('.qv-wrapper').removeClass('loading');
  });
}


function prepareQvThumbnails(images) {
  var rtlFlag = ($('body').hasClass('lang-rtl')) ? true: false;
	var thumbnailContainer = $('#qv-thumbnails');
    var thumbnailSliderWrapper = $('<div class="owl-carousel"></div>')
    $(images).each(function (i,src) {
      thumbnailSliderWrapper.append('<div class="thumb-item item"><img data-src="' + src +'" alt="qv-img" class="lazyload"></div>');
    });
    thumbnailContainer.html(thumbnailSliderWrapper);
    thumbnailSliderWrapper.owlCarousel({
      nav: true,
      navText: [
        '<i class=\'fa fa-angle-left\'></i>',
        '<i class=\'fa fa-angle-right\'></i>'
      ],
      dots: false,
      loop: false,
      margin: 15,
      rtl: rtlFlag,
      rewind: true,
      responsive:  {
        0: {
          items: 3
        },
        544: {
          items: 4
        },
        768: {
          items: 3
        },
        992: {
          items: 4
        },
        1200: {
          items: 4
        }
      }
  	});

}

function loadCurrentQvVariants() {
  //load current variants
  $('#qv-variants .dropdown-wrapper').each(function(index){
    currentVariants["select-option" + (index+1)] = $(this).find('select.select__select').val();
  });
}

function updateQvVariantDetails() {
  var index=0;
  var available = false;
  for(var i=0; i < availableVariants.length;) {
    if(matchArray(availableVariants[i],currentVariants)) {
      index = i;
    }
    if(matchArray(availableVariants[i],currentVariants) && variantAvailability[i]) {
      available = true;
      break;
    }
     i++;
  }
  
  $("#qv-variantid").val(variantIndexIdMapping[index]);
  
  if(available){
    $("#qv-add-to-cart").removeClass("sold-out");
  } else {
    $("#qv-add-to-cart").addClass("sold-out");
  }
  
  $("#qv-product-cover img").attr("src", variantFeaturedImg[index]);
  
  var price = variantPrice[index];
  var compare_at_price = variantCompareAtPrice[index];
  if(compare_at_price != null && compare_at_price > price) {
    $("#qv-compareatprice").html(convertToMoney(compare_at_price));
    $("#qv-price").html(convertToMoney(price));
  } else {
    $("#qv-compareatprice").html('');
    $("#qv-price").html(convertToMoney(price));
  }
}

function matchArray(a, b) {
  var match = true;
  for (var key in a) {
    if(a[key] != b[key]) {
      match = false;
    }
  }
  return match;
}

$(document).on("change","#qv-variants .select__select",function(){
  loadCurrentQvVariants();
  updateQvVariantDetails();
});
 
$(document).on("click",".swatch-wrapper label",function() {
  var selectorIndex = $(this).parents(".swatch-wrapper").data("index");
  var selector = "#select-option" + selectorIndex  + " option";
  var index = $(this).data("index");
  $(selector).eq(index).prop('selected', true).trigger('change');
});

$(document).on("click",".thumb-item",function(){
  $("#qv-product-cover img").attr("src",$(this).find("img").attr("src"))
});

$(document).on("click","#qv-add-to-cart",function(){
  if($(this).hasClass("sold-out")) return false;
  var variantId = $("#qv-variantid").val();
  var qty = $("#qv-quantity-selector input").val();
  $(this).addClass("loading");
  addToCartJS(qty,variantId, this);
  $("#ModalClose-quick-view").trigger("click");
});

//QUICKVIEW FUNCTIONS END

// MOBILE ADD TO CART BTN STICKY JS START

  if(window.matchMedia('(max-width: 991px)').matches) { 
    $(window).scroll(function () {
      if ($(this).scrollTop() > 1000) {
        $('.sticky-cartbtn').fadeIn(500);
      } else {
        $('.sticky-cartbtn').fadeOut(500);
      }
    });
  }
  $(document).on("click", ".stickyaddtocart", function() {
    $(".product-form__submit").trigger('click');
  }); 

// MOBILE ADD TO CART BTN STICKY JS END

//ISHI FUNCTIONS END





  document.addEventListener("DOMContentLoaded", function() {
    var cartUpsell = document.getElementById('cart-upsell');
    var cartDrawerGift = document.getElementById('cart-drawer-gift');
    if (cartUpsell) cartUpsell.style.display = 'none';
    if (cartDrawerGift) cartDrawerGift.style.display = 'none';
    function handleCartChanges() {
        var cartEmpty = document.querySelector('.cart-empty');
        if (!cartEmpty) {
            if (cartUpsell) cartUpsell.style.display = 'block';
            if (cartDrawerGift) cartDrawerGift.style.display = 'block';
        } else {
            if (cartUpsell) cartUpsell.style.display = 'none';
            if (cartDrawerGift) cartDrawerGift.style.display = 'none';
        }
    }
    handleCartChanges();
    document.addEventListener('DOMSubtreeModified', handleCartChanges);
});

// Add on upsell product js start

function showPopup(p_id) {
    const overlay = document.getElementById('overlay_' + p_id);
    const popup = document.getElementById('popup_' + p_id);

    overlay.style.display = 'block';
    popup.classList.add('active');

    // // Adding event listener to the close button
    // const closeBtn = document.getElementById('closeBtn');
    // closeBtn.addEventListener('click', function() {
    //     hidePopup(p_id);
    // });
document.body.addEventListener('click', function(event) {
    // Check if the clicked element is a close button
    if (event.target && event.target.id === 'closeBtn') {
        // Find the parent popup element ID
        const popupId = event.target.closest('.popup').id.split('_')[1];
        // Call hidePopup function with the popup ID
        hidePopup(popupId);
    }
});
    // Adding event listener to the overlay
    overlay.addEventListener('click', function(event) {
        if (event.target === overlay) {
            hidePopup(p_id);
        }
    });
}

function hidePopup(p_id) {
    const overlay = document.getElementById('overlay_' + p_id);
    const popup = document.getElementById('popup_' + p_id);

    overlay.style.display = 'none';
    popup.classList.remove('active');
}

document.addEventListener('DOMContentLoaded', function () {
    const popups = document.querySelectorAll('.upsell-product-popup');
    
    popups.forEach(function(popup, index) {
        const cartBtn = popup.querySelector('.popupbtn');
        const p_id = cartBtn.dataset.productId;

        cartBtn.addEventListener('click', function() {
            showPopup(p_id);
        });
    });
});
document.addEventListener('DOMContentLoaded', function() {
    const addToCartButtons = document.querySelectorAll('.ajax-cart-btn');
    addToCartButtons.forEach(function(button) {
        button.addEventListener('click', function() {
            const popupId = this.closest('.popup').id.split('_')[1];
            hidePopupWithTransition(popupId);
        });
    });
});
function hidePopupWithTransition(p_id) {
    const popup = document.getElementById('popup_' + p_id);
    popup.style.transition = 'opacity 0.5s';
    // Set opacity to 0 with a transition effect
    popup.style.opacity = '0';
    // Hide the popup after the transition ends
    setTimeout(function() {
        hidePopup(p_id);
    }, 500);
}
function hidePopup(p_id) {
    const overlay = document.getElementById('overlay_' + p_id);
    const popup = document.getElementById('popup_' + p_id);
    overlay.style.display = 'none';
    popup.classList.remove('active');
    // Restore opacity to 1 after hiding the popup
    popup.style.opacity = '1';
}

$(document).ready(function() {
  $(".Add-on").on("click", function() {
    $(this).parents(".variants-swatch").find(".Add-on").removeClass("active");
    $(this).addClass("active");
    var popupSelector = $(this).parents(".popup").attr("id");
    var valuesArray = "";
    $(this).parents(".popup").find(".Add-on.active").each(function() {
      var optionValue = $(this).data("value");
      valuesArray = `${valuesArray} ${optionValue}`;
    }); 
    console.log("valuesArray = ", valuesArray);
    var trimmedValue = String(valuesArray).trim();
        selectedVariant = $(`#${popupSelector} .select__select option[data-variant="${trimmedValue}"]`);
        onChangeGetVariantID = selectedVariant.attr("value");
    console.log(onChangeGetVariantID, "onChangeGetVariantID==============");
    $(this).parents(".popup").find(".product-form input[name='id']").val(onChangeGetVariantID);
  }); 
});
buttonTextChange();
function buttonTextChange() {
  if (window.location.href.indexOf("products") > -1){
    $(".upsell-product").each(function(){
     var upsellProductHandle = $(this).data("handle");
      console.log("upsellProductHandle => ", upsellProductHandle);
     $.ajax({
         type: 'GET',
         url: '/cart.json',
         dataType: 'jsonp',
         success: function(data) {
           var items = data['items'];
           for (var i = 0; i < items.length; i++) {
               if (items[i]["handle"] == upsellProductHandle) {
                 $(".upsell-product[data-handle="+upsellProductHandle+"] .popupbtn span").text("Added");
               }
           }
         }
     });
    });
  }
}
document.addEventListener("DOMContentLoaded", function() {
    var cartBtn = document.getElementById("cart-btn");
    var popup = document.querySelector(".popup");

    if (cartBtn && popup) {
        cartBtn.addEventListener("click", function() {
            popup.classList.add("active");
        });
    }
});

// dispatch timer start

 $(document).ready(function () {
   var dayTimeUpdated = false;
    function updateTimer() {
        var now = new Date();
        var targetTime = new Date(now);
        var currentDate = new Date();
        var deliveryDay = parseInt($('.delivery-text .day-time').data("day"));
        var dispatch = $('.dispatch_enabled').attr('data-dispatch-value');
        var delivery_time = parseInt($('.dispatch_enabled').attr('data-delivery-minites'));
        var cutofftime = parseInt($('.dispatch_enabled').attr('data-cutoff'));

        if (dispatch === 'true') {
            if (currentDate.getHours() < cutofftime) {
                // If before cutofftime, use today's date
                var options = { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' };
                var formattedDate = currentDate.toLocaleDateString('en-US', options);
                if (!dayTimeUpdated) {
                  $(".delivery-text .day-time").text(formattedDate);
                 }
            } else {
                // If after cutofftime, use deliveryDay days from now
                currentDate.setDate(currentDate.getDate() + deliveryDay);
                var options = { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' };
                var formattedDate = currentDate.toLocaleDateString('en-US', options);
                 if (!dayTimeUpdated) {
                  $(".delivery-text .day-time").text(formattedDate);
                 }
            }
            dayTimeUpdated = true;
        } else {
            // If dispatch is not enabled, use deliveryDay days from now
            currentDate.setDate(currentDate.getDate() + deliveryDay);
            var options = { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' };
            var formattedDate = currentDate.toLocaleDateString('en-US', options);
             if (!dayTimeUpdated) {
              $(".delivery-text .day-time").text(formattedDate);
             }
            dayTimeUpdated = true;
        }
    }

    setInterval(updateTimer, 1000);

    var cutofftime = parseInt($('.dispatch_enabled').attr('data-cutoff'));
    var delivery_time = parseInt($('.dispatch_enabled').attr('data-delivery-minites'));
    var now = new Date();
    var time;

    if (now.getHours() < cutofftime) {
       // If after cutofftime, set the countdown to delivery_time minutes from now
        now.setMinutes(now.getMinutes() + delivery_time);
        time = now;
    } else {
        // If after cutofftime, set the countdown to delivery_time minutes from now
        now.setMinutes(now.getMinutes() + delivery_time);
        time = now;
    }

    var timer = setInterval(function () {
        var left = time - new Date();
        var minutes = Math.floor(left / (1000 * 60));
        var seconds = Math.floor((left % (1000 * 60)) / 1000);

        if (seconds < 10) {
            seconds = "0" + seconds;
        }

        var timerElement = document.querySelector('div#timer>b');
        if (timerElement) {
            timerElement.innerHTML = minutes + ':' + seconds;
        }

        if (left <= 0) {
            clearInterval(timer);
            location.reload();
        }
    }, 1000);
});

// dispatch timer end

